import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import { schedulePage, getCapitalizedName } from '../../utils';
import { virtualPageView } from '../../googleTagManager';
import './BigEventCard.scss';

const sendVirtualPage = (name = '') => {
  if (!name) return;
  virtualPageView('plan my day', 'schedule', `/ga-virtual/plan-my-day/schedule/${name.toLowerCase().replace(' ', '-')}`);
};

const BigEventCard = ({ event, numOfUnits, fullName }) => {
  const history = useHistory();
  useEffect(() => {
    if (!event) history.push(schedulePage);
  }, [event, history]);

  const {
    name,
    location,
    startTime,
    endTime,
    startDate,
    slotColor,
    numOfGuests,
  } = event || {};

  useEffect(() => {
    sendVirtualPage(name);
  }, [name]);

  const guestsText = numOfGuests - 1 > 0
    ? `${getCapitalizedName(fullName)} +${numOfGuests - 1}`
    : getCapitalizedName(fullName);
  const timeString = !endTime ? startTime : `${startTime} - ${endTime}`;
  const date = moment(startDate).format('Do MMMM');
  const unitText = numOfUnits === 1 ? '(1 unit)' : `(${numOfUnits} units)`;
  return (
    <div className={classnames('big-event-card', slotColor)}>
      <div className="start-date">{date}</div>
      <div className="fake-header" />
      <div className="name">{name}</div>
      <div className="guests">{guestsText}</div>
      <div className="units">{unitText}</div>
      {!!location && <div className="location">{location}</div>}
      <div className="start-time">{timeString}</div>
      <div className="fake-footer" />
    </div>
  );
};

BigEventCard.propTypes = {
  event: PropTypes.object,
  numOfUnits: PropTypes.number,
  fullName: PropTypes.string,
};

export default BigEventCard;
